import { css } from "@emotion/react";
import TxtWithScroll from "../atoms/TxtWithScroll";
import { guidance } from "./guidance";

const Guidance: React.FC = () => {
  return (
    <div css={mainStyle} id="guide">
      <div css={titleMainStyle}>
        <div css={titleContainerStyle}>
          <div css={titleWrapperStyle}>
            <div css={upperTitleWrapperStyle}>
              <div css={borderStyle}></div>
              <div css={titleStyle}>ご来場の皆様へご案内</div>
              <div css={borderStyle}></div>
            </div>
          </div>
        </div>
      </div>
      <div css={containerStyle}>
        <TxtWithScroll
          width={320}
          height={200}
          backgroundColor="#FDF4F4"
          txt={guidance}
        />
      </div>
      <div css={whiteSpaceStyle}></div>
    </div>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
  padding: 20px 0 0;
`;

const whiteSpaceStyle = css`
  height: 20px;
  width: 100%;
  background-color: #fff;
`;

const titleMainStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const titleContainerStyle = css`
  width: 100%;
  max-width: 500px;
  padding: 15px 20px;
`;

const titleWrapperStyle = css``;

const upperTitleWrapperStyle = css`
  display: flex;
  align-items: center;
`;

const containerStyle = css`
  padding: 0 0 40px;
  display: flex;
  justify-content: center;
`;

const borderStyle = css`
  height: 1px;
  background-color: ${primaryColor};
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
`;

export default Guidance;
